import Users from '@/api/users.js'
import * as Sentry from '@sentry/browser'

export default {
  namespaced: true,

  state: {
    apiToken: null,
    refreshToken: null,
    user: null
  },

  getters: {
    isAuthenticated: (state) => Boolean(state.apiToken) && Boolean(state.user),
    hasActiveSubscription: (state) =>
      Boolean(state.user?.has_active_subscription),
    hadActiveSubscription: (state) =>
      Boolean(state.user?.had_active_subscription)
  },

  mutations: {
    setApiToken(state, token) {
      state.apiToken = token.access
      state.refreshToken = token.refresh
    },
    setUser(state, user) {
      state.user = user
      // if(process.env.NODE_END !== 'development') Sentry.setUser({ email: user.email })
    },
    addFavorite(state, { type, id }) {
      state.user[`favorite_${type}`].push(id)
    },
    removeFavorite(state, { type, id }) {
      state.user[`favorite_${type}`] = state.user[`favorite_${type}`].filter(
        (x) => x !== id
      )
    },
    disconnect(state) {
      for (const property in state) {
        state[property] = null
      }
      localStorage.removeItem('index-acta')
    }
  },

  actions: {
    login({ commit }, { token }) {
      return new Promise((resolve, reject) => {
        commit('setApiToken', token)
        Users.getCurrent().then((response) => {
          commit('setUser', response)
          resolve()
        })
      })
    },
    async updateUser({ commit }, { }) {
      return Users.getCurrent().then((response) => {
        commit('setUser', response)
      })
    },
    addFavorite({ commit }, { type, id }) {
      commit('addFavorite', { type, id })
    },
    removeFavorite({ commit }, { type, id }) {
      commit('removeFavorite', { type, id })
    }
  }
}
